<template>
    <span>
        <b-icon v-if="validity == 'valid'" icon="check-circle" variant="success" :scale="iscale" v-b-tooltip.hover
            :title="$t('infovalidityicon.valid')" />
        <b-icon v-if="validity == 'expired'" icon="x-circle" variant="secondary" :scale="iscale" v-b-tooltip.hover
            :title="$t('infovalidityicon.expired')" />
        <b-icon v-if="validity == 'upcoming'" icon="check-circle" variant="warning" :scale="iscale" v-b-tooltip.hover
            :title="$t('infovalidityicon.upcoming')" />
        <b-icon v-if="validity == '?'" icon="question-circle" variant="danger" :scale="iscale" v-b-tooltip.hover
            :title="$t('infovalidityicon.unknown')" />
    </span>
</template>

<script>
export default {
    name: 'InfoValidityIcon',
    props: ['info', 'scale'],
    computed: {
        validity() {
            var validity = "?";
            if (this.info && this.info.ajastusList) {
                let now = Date.now();
                this.info.ajastusList.forEach(schedule => {
                    var from = Date.parse(schedule.validityBegins);
                    var to = Date.parse(schedule.validityEnds);
                    if (from <= now && to >= now) validity = "valid";
                    if (from > now && validity != "valid") validity = "upcoming";
                    if (to < now && validity != "valid" && validity != "upcoming") validity = "expired";
                });
            } else if (this.info && this.info.validity_begins && this.info.validity_ends) {
                let now = Date.now();
                var from = Date.parse(this.info.validity_begins);
                var to = Date.parse(this.info.validity_ends);
                if (from <= now && to >= now) validity = "valid";
                if (from > now && validity != "valid") validity = "upcoming";
                if (to < now && validity != "valid" && validity != "upcoming") validity = "expired";
            }
            return validity;
        },
        iscale() {
            return this.scale ? this.scale : "1";
        }
    }
}
</script>